import axios from "axios";
import jwt_decode from "jwt-decode";
import {API_URL} from "./config";
import {normalizeApiError} from "./apiError";
import {authEvents} from "./authEvents";

let accessToken = null;
let refreshPromise = null;

const refreshClient = axios.create({
    baseURL: API_URL,
    withCredentials: true,
});

export const authService = {
    setAccessToken(token) {
        accessToken = token || null;
    },

    getAccessToken() {
        return accessToken;
    },

    clearAccessToken() {
        accessToken = null;
    },

    forceLogout(reason = 'refresh_failed') {
        accessToken = null;
        authEvents.emitLogout(reason);
    },

    getPayload() {
        if (!accessToken) {
            return null;
        }

        try {
            return jwt_decode(accessToken);
        } catch (e) {
            accessToken = null;
            return null;
        }
    },

    isTokenExpired(offsetSeconds = 30) {
        const payload = this.getPayload();
        if (!payload?.exp) {
            return true;
        }

        const now = Math.floor(Date.now() / 1000);
        return payload.exp <= now + offsetSeconds;
    },

    async refreshAccessToken() {
        if (refreshPromise) {
            return refreshPromise;
        }

        refreshPromise = refreshClient
            .post('api/v1/refresh.php', {})
            .then(({data}) => {
                if (!data?.access_token) {
                    throw normalizeApiError(null, 'Сервер не вернул access token');
                }

                this.setAccessToken(data.access_token);
                return data;
            })
            .catch((error) => {
                const apiError = normalizeApiError(error, 'Не удалось обновить сессию');
                this.forceLogout('refresh_failed');
                throw apiError;
            })
            .finally(() => {
                refreshPromise = null;
            });

        return refreshPromise;
    },
};
